module.exports = __webpack_public_path__ + "img/hkis.3b854d20.png";